"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stats = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("../../components");
const Stats = (props) => {
    var _a;
    const RenderComponent = (_a = props.render) !== null && _a !== void 0 ? _a : components_1.ExampleStats;
    return (react_1.default.createElement(components_1.ResultStateProvider, { render: (renderProps) => react_1.default.createElement(RenderComponent, Object.assign({}, renderProps)) }));
};
exports.Stats = Stats;
//# sourceMappingURL=Stats.js.map